import { COLOR_VISION_EVENT } from '../constants.js';

function getColorVisionEventAttrs({
  type,
  index,
  watch = true
}) {
  return {
    [`${COLOR_VISION_EVENT.dataAttribute}-watch`]: watch,
    [`${COLOR_VISION_EVENT.dataAttribute}-type`]: type,
    [`${COLOR_VISION_EVENT.dataAttribute}-index`]: index
  };
}

export { getColorVisionEventAttrs };
